// import React, { useEffect, useState } from "react";
// import { useParams, Link } from "react-router-dom";
// import ReactMarkdown from "react-markdown";

// export default function BlogDetails() {
// 	const { slug } = useParams();
// 	const [blog, setBlog] = useState(null);
// 	const [markdown, setMarkdown] = useState("");

// 	useEffect(() => {
// 		fetch("/blogs.json")
// 			.then((res) => res.json())
// 			.then((blogs) => {
// 				const found = blogs.find((b) => b.slug === slug);
// 				setBlog(found);
// 				if (found) {
// 					fetch(`/blogs/${found.file}`)
// 						.then((res) => res.text())
// 						.then(setMarkdown);
// 				}
// 			});
// 	}, [slug]);

// 	if (!blog) return <div>Blog not found</div>;

// 	return (
// 		<div
// 			style={{
// 				maxWidth: 800,
// 				margin: "20px auto",
// 				background: "#fff",
// 				padding: 32,
// 				borderRadius: 12,
// 			}}>
// 			<Link to='/blogs' style={{ textDecoration: "none", color: "#007bff" }}>
// 				← Back to Blogs
// 			</Link>
// 			<img
// 				src={blog.imageUrl}
// 				alt={blog.title}
// 				style={{ width: "100%", borderRadius: 8, margin: "24px 0" }}
// 			/>

// 			<ReactMarkdown>{markdown}</ReactMarkdown>
// 		</div>
// 	);
// }

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BlogFullLeft from "./BlogFullLeft";
import BlogFullRight from "./BlogFullRight";
import "./BlogFullDetails.css";
import SimpleWrapper from "../components/SimpleWrapper";

export default function BlogDetails() {
	const { slug } = useParams();
	const [blog, setBlog] = useState(null);
	const [markdown, setMarkdown] = useState("");
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const loadBlog = async () => {
			setLoading(true);
			try {
				const res = await fetch("/blogs.json");
				const blogs = await res.json();
				const found = blogs.find((b) => b.slug === slug);
				setBlog(found);
				if (found) {
					const mdRes = await fetch(`/blogs/${found.file}`);
					const text = await mdRes.text();
					setMarkdown(text);
				}
			} catch (err) {
				console.error("Error loading blog:", err);
			} finally {
				setLoading(false);
			}
		};
		loadBlog();
	}, [slug]);

	if (loading) {
		return (
			<SimpleWrapper searchVisible={false} navigation={false}>
				<div className='blog-loading'>
					<div className='loading-spinner'></div>
					<p>Loading blog content...</p>
				</div>
			</SimpleWrapper>
		);
	}

	if (!blog) {
		return (
			<div className='blog-not-found'>
				<h2>Blog not found</h2>
				<p>The blog post you're looking for doesn't exist.</p>
			</div>
		);
	}

	return (
		<SimpleWrapper searchVisible={false} navigation={false}>
			<div className='py-8 bg-white'>
				<div className='container mx-auto px-4'>
					<div className='flex flex-col lg:flex-row gap-8'>
						{/* Left: Main Blog Content */}
						<div className='w-full lg:w-2/3'>
							<BlogFullLeft blog={blog} markdown={markdown} />
						</div>
						{/* Right: Sticky Sidebar */}
						<aside className='w-full  lg:w-1/3'>
							<div className='sticky top-24'>
								<BlogFullRight />
							</div>
						</aside>
					</div>
				</div>
			</div>
		</SimpleWrapper>
	);
}
